import {AxiosInstance} from "axios";
import {EditLeadCategoryApiDto} from "./model/rest";
import DictionaryItem from "../model/dictionary/DictionaryItem";

export default class CategoryApi {
	constructor(public readonly axiosInstance: AxiosInstance) { }

	/**
	 * Fetch categories
	 * @return {Promise<DictionaryItem[]>} Promise containing fetched categories.
	 */
	fetchCategories(): Promise<DictionaryItem[]> {
		const url = `/api/web/leads/categories`;
		return this.axiosInstance.get(url).then(resp => resp.data.map(DictionaryItem.fromJson));
	}

	/**
	 * Create category.
	 * @param data Category data
	 * @returns {Promise<DictionaryItem>}
	 */
	createCategory(data: EditLeadCategoryApiDto): Promise<DictionaryItem> {
		const url = `/api/web/leads/categories`;
		return this.axiosInstance.post(url, data).then(resp => DictionaryItem.fromJson(resp.data));
	}

	/**
	 * Update category.
	 * @param {string} categoryId
	 * @param data data Category data
	 * @returns {Promise<DictionaryItem>}
	 */
	updateCategory(categoryId: string, data: EditLeadCategoryApiDto): Promise<DictionaryItem> {
		const url = `/api/web/leads/categories/${categoryId}`;
		return this.axiosInstance.put(url, data).then(resp => DictionaryItem.fromJson(resp.data));
	}

	/**
	 * Update lead category sort order.
	 * @param {string[]} leadCategoryIds
	 * @returns {Promise<any>}
	 */
	updateCategoriesSortOrder(leadCategoryIds: string[]) {
		const url = `/api/web/leads/categories/orders`;
		return this.axiosInstance.put(url, leadCategoryIds);
	}
}
